module.exports = __webpack_public_path__ + "img/第1章_2-3_小逸堂合照.jpg";